export default "__VITE_ASSET__DCtdH4vV__"